module.exports = __webpack_public_path__ + "static/media/poster_wide_s4.f079ac43.png";